module.exports = __webpack_public_path__ + "static/media/33.7733bef7.png";